import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store for articles
const articlesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/articles",
  name: "ArticlesStoreRefactor",
  objectName: "Article",
  enableCache: true, // Enable 5-minute cache for articles
  actionCableChannel: null, // Disable ActionCable for articles unless needed
  infiniteLoading: false, // Simple list without pagination
});

export const useArticlesStoreRefactor = defineStore("articlesRefactor", {
  ...articlesBaseStore,

  state: () => ({
    ...articlesBaseStore.state(),
  }),

  getters: {
    ...articlesBaseStore.getters,

    // Get article by ID with recursive loading - backward compatibility
    getByIdWithRecursive: (state) => (id) => {
      return state.data.find((article) => article.id === id);
    },
  },

  actions: {
    ...articlesBaseStore.actions,
  },
});
